/**
 * Per-conversation preference for the page inspector's default state. We key by
 * conversationId so different conversations can carry independent
 * preferences (toggling inspect off in one conversation should not leak
 * into another). Default is ON — section-targeted editing is the
 * primary flow and the rationale for this commit.
 */
export const INSPECTOR_PREF_KEY_PREFIX = 'xavior.pages.inspector.';

export function readInspectorPreference(conversationId?: string): boolean {
  if (!conversationId || typeof window === 'undefined') return true;
  try {
    const raw = window.localStorage.getItem(INSPECTOR_PREF_KEY_PREFIX + conversationId);
    if (raw === null) return true; // default ON
    return raw !== 'off';
  } catch {
    return true;
  }
}

export function writeInspectorPreference(conversationId: string | undefined, on: boolean): void {
  if (!conversationId || typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(INSPECTOR_PREF_KEY_PREFIX + conversationId, on ? 'on' : 'off');
  } catch {
    /* ignore quota / private mode */
  }
}
